import { useCallback, useEffect, useState } from 'preact/hooks';
import { useControls } from './useControls';

const listeners: boolean[] = [];
const areAllDone = () => listeners.reduce((a, v) => a && v, true);

export function useAdLoaded() {
  const { setAdLoaded } = useControls();
  const [isDone, setDone] = useState(false);
  const [index, setIndex] = useState(-1);
  useEffect(() => {
    setIndex(listeners.push(false) - 1);
  }, []);
  useEffect(() => {
    if (index === -1) return;
    if (!isDone) return;
    listeners[index] = true;
    if (areAllDone()) {
      setAdLoaded?.();
    }
  }, [index, isDone]);

  useEffect(() => () => (listeners[index] = true), []);

  return useCallback(() => setDone(true), [index]);
}
